<template>
  <span style="cursor: pointer;" @click="show = !show">
    <v-tooltip v-model="show" activator="parent" location="top" color="primary">
      <span>{{ dateTimeString }}</span>
    </v-tooltip>
    <span class="underline hover:no-underline">{{ dateTimeTitle }}</span>
  </span>
</template>

<script setup>
  import moment from 'moment'
  import { computed, ref } from 'vue'

  defineOptions({
    name: 'DateTimeTooltip',
  })

  const props = defineProps({
    dateString: {
      type: String,
      required: true,
    },
    dateTitle: {
      type: String,
    }
  })

  const show = ref(false)

  const dateTimeTitle = computed(() => {
    return props.dateTitle ?
      props.dateTitle :
      moment(props.dateString).fromNow()
  })

  const dateTimeString = computed(() => {
    return moment(props.dateString).format('lll')
  })
</script>
